import { analyticsClickListener } from '../analytics/analytics';
import { AnalyticsKategori } from '../analytics/types';
import { CustomEvents } from '../events';
import headerClasses from '../styles/header.module.css';
import { defineCustomElement } from './custom-elements';

class ContextLinks extends HTMLElement {
	handleParamsUpdated = (event: CustomEvent<CustomEvents['paramsupdated']>) => {
		if (event.detail.changedKeys.includes('context')) {
			const { context } = event.detail.params;
			this.querySelectorAll('a').forEach((anchor) => {
				anchor.classList.toggle(headerClasses.lenkeActive, anchor.getAttribute('data-context') === context);
			});
		}
	};

	connectedCallback() {
		this.addEventListener(
			'click',
			analyticsClickListener((anchor) => ({
				kategori: (anchor.getAttribute('data-kategori') as AnalyticsKategori) ?? undefined,
				lenkegruppe: 'arbeidsflate-valg',
				lenketekst: anchor.getAttribute('data-context') ?? undefined,
			}))
		);
		window.addEventListener('paramsupdated', this.handleParamsUpdated);
	}

	disconnectedCallback() {
		window.removeEventListener('paramsupdated', this.handleParamsUpdated);
	}
}

defineCustomElement('context-links', ContextLinks);
